import React, { useState, useEffect } from 'react'
import Panel from './Panel'
import styled from '@emotion/styled'
import { h2 } from '@/styles/typography'
import Share from './Panel/Share'
import { spacing, screen, grid, ratio, fontSize } from '@/styles/mixins'

const Paneles = styled.div`
  text-align: center;
  background-color: #222222;
  position: relative;
  .mark {
    position: fixed;
    bottom: 10px;
    right: 20px;
    font-family: 'Acta Sans', sans-serif;
    text-transform: uppercase;
    opacity: 0.6;
    transition: opacity 0.2s ease-in-out;
    /* pointer-events: auto; */
    z-index: 2;
    &:hover {
      opacity: 1;
    }
  }
`

const Extra = styled.div`
  position: relative;
  z-index: 3;
  height: 140vh;
  color: white;
  margin-left: 1rem;
  margin-right: 1rem;
  h2 {
    ${h2}
    ${spacing(['mt', 'mb'])}
    max-width: 540px;
    margin-right: auto;
    margin-left: auto;
    text-shadow: rgb(0 0 0 / 90%) 0px 0px 2px, rgb(0 0 0 / 60%) 0px 0px 20px;
  }
  .excerpt {
    margin-top: 3rem;
    margin-right: auto;
    margin-left: auto;
    max-width: 540px;
    text-shadow: rgb(0 0 0 / 90%) 0px 0px 2px, rgb(0 0 0 / 60%) 0px 0px 20px;
    pointer-events: none;

    p {
      background-color: rgba(0, 0, 0, 0.4);
      box-shadow: 15px 7px 0 rgba(0, 0, 0, 0.2), -15px -5px 0 rgba(0, 0, 0, 0.2),
        15px -5px 0 rgba(0, 0, 0, 0.2), -15px 7px 0 rgba(0, 0, 0, 0.2);
      font-size: 1.4rem;
      margin-bottom: 1rem;
      padding-bottom: 0;
      a {
        text-decoration: underline;
        pointer-events: auto;
      }
      @media (orientation: portrait) {
        font-size: 1.2rem;
      }
    }
  }
`

const PanelesComponent = props => {
  const { attrs, innerBlocks, innerHTML, extra } = props

  const paneles = JSON.parse(decodeURIComponent(attrs.paneles))
  const [active, setActive] = useState(0)

  return (
    <Paneles>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        style={{
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
        }}>
        <defs>
          <symbol id="facebook-icon-rounded" viewBox="0 0 24 24">
            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v2z" />
          </symbol>
          <symbol id="twitter-icon-rounded" viewBox="0 0 24 24">
            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.066 9.645c.183 4.04-2.83 8.544-8.164 8.544-1.622 0-3.131-.476-4.402-1.291 1.524.18 3.045-.244 4.252-1.189-1.256-.023-2.317-.854-2.684-1.995.451.086.895.061 1.298-.049-1.381-.278-2.335-1.522-2.304-2.853.388.215.83.344 1.301.359-1.279-.855-1.641-2.544-.889-3.835 1.416 1.738 3.533 2.881 5.92 3.001-.419-1.796.944-3.527 2.799-3.527.825 0 1.572.349 2.096.907.654-.128 1.27-.368 1.824-.697-.215.671-.67 1.233-1.263 1.589.581-.07 1.135-.224 1.649-.453-.384.578-.87 1.084-1.433 1.489z" />
          </symbol>
          <symbol id="reddit-icon-rounded" viewBox="0 0 24 24">
            <path d="M14.238 15.348c.085.084.085.221 0 .306-.465.462-1.194.687-2.231.687l-.008-.002-.008.002c-1.036 0-1.766-.225-2.231-.688-.085-.084-.085-.221 0-.305.084-.084.222-.084.307 0 .379.377 1.008.561 1.924.561l.008.002.008-.002c.915 0 1.544-.184 1.924-.561.085-.084.223-.084.307 0zm-3.44-2.418c0-.507-.414-.919-.922-.919-.509 0-.923.412-.923.919 0 .506.414.918.923.918.508.001.922-.411.922-.918zm13.202-.93c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-5-.129c0-.851-.695-1.543-1.55-1.543-.417 0-.795.167-1.074.435-1.056-.695-2.485-1.137-4.066-1.194l.865-2.724 2.343.549-.003.034c0 .696.569 1.262 1.268 1.262.699 0 1.267-.566 1.267-1.262s-.568-1.262-1.267-1.262c-.537 0-.994.335-1.179.804l-2.525-.592c-.11-.027-.223.037-.257.145l-.965 3.038c-1.656.02-3.155.466-4.258 1.181-.277-.255-.644-.415-1.05-.415-.854.001-1.549.693-1.549 1.544 0 .566.311 1.056.768 1.325-.03.164-.05.331-.05.5 0 2.281 2.805 4.137 6.253 4.137s6.253-1.856 6.253-4.137c0-.16-.017-.317-.044-.472.486-.261.82-.766.82-1.353zm-4.872.141c-.509 0-.922.412-.922.919 0 .506.414.918.922.918s.922-.412.922-.918c0-.507-.413-.919-.922-.919z" />
          </symbol>
          <symbol id="whatsapp-icon-rounded" viewBox="0 0 24 24">
            <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.072.045.419-.1.824zm-3.423-14.416c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm.029 18.88c-1.161 0-2.305-.292-3.318-.844l-3.677.964.984-3.595c-.607-1.052-.927-2.246-.926-3.468.001-3.825 3.113-6.937 6.937-6.937 1.856.001 3.598.723 4.907 2.034 1.31 1.311 2.031 3.054 2.03 4.908-.001 3.825-3.113 6.938-6.937 6.938z" />
          </symbol>
        </defs>
      </svg>
      {extra && <Extra id="#start">{extra}</Extra>}
      {paneles.map((panel, index) => {
        return (
          <Panel
            key={index}
            panel={panel}
            index={index}
            totalLength={paneles.length}
            active={active}
            onActive={as => setActive(as)}
          />
        )
      })}
      {paneles[active].fondo && (
        <div className="mark">
          <Share
            key={`panel-${active + 1}`}
            comparte={`Compartir imagen #${active + 1}`}
            url={`https://interactivo.latercera.com/18o/plaza-cero/panel-${
              active + 1
            }/`}
            title={`Plaza Cero: Imagen ${
              active + 1
            } - Interactivo La Tercera. ${
              paneles[active].cuerpo
                ? paneles[active].cuerpo
                    .replace(/<\/?[^>]+(>|$)/g, '')
                    .substring(0, 140) + '...'
                : ''
            } `}
            hashtags="18O"
          />
        </div>
      )}
    </Paneles>
  )
}

export default PanelesComponent
